import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";
import { ProfileView } from "../components/profile";

export const BaseLayout = () => {
  return (
    <>
      <ProfileView />
      <Sidebar />
      <Outlet />
      {/* <Footer /> */}
    </>
  );
};
